<template>
  <div>
    <van-tabbar v-model="active">
      <van-tabbar-item
        v-for="(item, index) in list"
        :key="index"
        :to="item.path"
      >
        <span>{{ item.name }}</span>
        <template #icon="props">
          <img :src="props.active ? item.active : item.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          index: 0,
          name: "首页",
          active: require("../../../src/assets/images/icon_Syuyue.png"),
          inactive: require("../../../src/assets/images/icon_yuyue.png"),
          path: "/homes",
        },
        {
          index: 1,
          name: "预约",
          active: require("../../../src/assets/images/icon_Sfuwu.png"),
          inactive: require("../../../src/assets/images/icon_fuwu.png"),
          path: "/home",
        },
        {
          index: 2,
          name: "中心店",
          active: require("../../../src/assets/images/icon_Smendian.png"),
          inactive: require("../../../src/assets/images/icon_mendian.png"),
          path: "/center",
        },

        {
          index: 3,
          name: "我的",
          active: require("../../../src/assets/images/icon_Swode.png"),
          inactive: require("../../../src/assets/images/icon_wode.png"),
          path: "/my",
        },
      ],
    };
  },
  mounted() {
    // console.log(this.$route.meta.activeNum);
  },
  computed: {
    active: {
      get() {
        return this.$route.meta.activeNum;
      },
      set() {},
    },
  },
};
</script>
<style  scoped>

</style>
